module.exports = __webpack_public_path__ + "static/img/logo_transparent.cfbeb58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_transparent.png
// module id = FAf8
// module chunks = 1